<template>
  <div id="app">
    <template v-if="checkedUserState">
<!--      没有token或地址为登录页 则进入登录页-->
      <template v-if="!token || pages">
        <router-view v-if="pages"></router-view>
      </template>
<!--      否则，即有token同时地址不为登录页时 进入对应页面-->
      <template v-else>
        <app-layout></app-layout>
      </template>
    </template>
    <template v-else>
      <!-- loading... -->
    </template>
  </div>
</template>

<script>
  import AppLayout from "./views/layout/app-layout";
  import {mapGetters} from "vuex";
  import {PAGE_ROUTES} from "./utils/const";

  export default {
    name: 'App',
    components: {AppLayout},
    computed: {
      ...mapGetters(['token', 'checkedUserState']),
      pages() {
        return PAGE_ROUTES.includes(this.$route.path);
      }
    }
  }
</script>

<style lang="scss">
  @import "assets/styles/app";
  #app {
    font-family: PingFangSC-Regular,PingFang SC,-apple-system,Microsoft YaHei,Verdana,Din Alternate,BlinkMacSystemFont,Segoe UI,Hiragino Sans GB,Helvetica Neue,Helvetica,Arial,sans-serif;
    color: #333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #_qd_schema_0, #_qd_schema_1, #_qd_schema_2, #_qd_schema_3, #_qd_schema_4, #_qd_schema_5,
  #_qd_schema_6, #_qd_schema_7, #_qd_schema_8, #_qd_schema_9, #_qd_schema_10, #_qd_schema_11,
  #_qd_schema_12, #_qd_schema_13, #_qd_schema_14, #_qd_schema_15, #_qd_schema_16, #_qd_schema_17 {
    display: none;
  }
  :focus {
    outline: none !important;
  }
  .test{
    // 测试 lmmmm
  }
</style>
